// extracted by mini-css-extract-plugin
module.exports = {"lobbyPage":"Lobby_lobbyPage__3YjD5","scramMaster":"Lobby_scramMaster__jjgUR","card":"Lobby_card__DTHUU"};